<template>
  <b-modal
    size="xl"
    id="policy-modal"
    title=""
    centered
    hide-footer>
    <div class="privacy-policy">
      <div>
        <h1 class=" anchor-headline rte-anchor-headline">
                                <span class="anchor-headline-link" id="h-datenschutz-3022"
                                      aria-label="Steuerkurs Anker">
                                </span>Datenschutz
        </h1>
        <p>Mit der Nutzung dieser Website erklären Sie sich mit der Nutzung Ihrer Daten wie in
          dieser Datenschutzerklärung beschrieben einverstanden:</p>
        <h2 class=" anchor-headline rte-anchor-headline">
                                <span class="anchor-headline-link"
                                      id="h-ueberlassene-informationen-speicherung-und-verarbeitung-3022"
                                      aria-label="Steuerkurs Anker">
</span>Überlassene Informationen: Speicherung und Verarbeitung</h2>
        <p>Ohne Ihre Zustimmung speichert die Webseite der Austrian Business Agency keine
          personenbezogenen Daten. Diese können Sie uns jedoch freiwillig für bestimmte Zwecke in
          den dafür ausgewiesenen Bereichen der Webseite hinterlassen (wie etwa Ihren Namen, Ihre
          E-Mail-Adresse, Ihre Telefonnummer im Rahmen einer Kontaktaufnahme).</p>
        <p>Sie können Daten mittels Formulare über die Website übermitteln, um beispielsweise einen
          Beratungstermin zu vereinbaren, Informationen anzufordern oder herunterzuladen oder
          unseren Newsletter zu bestellen. In solchen Fällen werden die Informationen, die Sie
          angeben, in unserem CRM gespeichert und genutzt, um den Beratungsprozess über den Standort
          Österreich aktiv gestalten und Ihnen ergänzende Informationen übersenden zu können.</p>
        <p>Sie können die Zustimmung zu dieser Datenspeicherung jederzeit widerrufen.</p>
        <p>Wir werden Sie nicht nach sogenannten sensiblen Daten (das sind Daten über rassische und
          ethnische Herkunft, politische Meinungen, religiöse oder philosophische Überzeugungen,
          Gewerkschaftszugehörigkeit, Gesundheit oder Sexualleben) fragen.</p>
        <p>Sie stimmen zu, dass wir Ihre persönlichen Daten, die Sie über die Website bekannt
          gegeben haben (insbesondere Name, E-Mail Adresse) und - soweit Sie dies angekreuzt haben -
          laut DSGVO auch für Marketingzwecke verwenden können oder an Dritte weitergeben.</p>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-datenschutz-bei-bewerbungen-3022"
                                                               aria-label="Steuerkurs Anker"></span>Datenschutz
          bei Bewerbungen</h2>
        <p>Sie stimmen zu, dass wir Ihre persönlichen Daten und Bewerbungsunterlagen, die Sie uns
          zur Verfügung gestellt haben, in eine Bewerber-Datenbank aufnehmen und verarbeiten, um Sie
          bei Stellenbesetzungsverfahren wieder aufzufinden und ansprechen zu können, falls Sie
          aufgrund der von Ihnen angegebenen Daten als potenzielle/r Kandidat/in in Betracht
          kommen.</p>
        <p>Sie können diese Zustimmung jederzeit widerrufen. Wir behalten uns vor, Teile oder
          sämtliche Ihrer Daten jederzeit ohne Rücksprache und ohne Angabe von Gründen zu löschen.
          Wir sind nicht verpflichtet, Ihre Daten im Rahmen eines Such- und Auswahlprozesses zu
          berücksichtigen und Sie haben keinen Rechtsanspruch auf Nutzung Ihrer Daten durch uns.
          Eine Haftung unsererseits gegenüber Ihnen ist ausgeschlossen, soweit gesetzlich
          zulässig.</p>
        <p>Über Ihr Ersuchen werden wir – nach Maßgabe gesetzlicher Bestimmungen (§§ 26, 27 DSG
          2000) - Auskunft über die zu Ihrer Person verarbeiteten Daten erteilen und unrichtige
          Daten richtigstellen oder löschen.</p>
        <ul></ul>
      </div>
      <div>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-informationsweitergabe-an-dritte-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Informationsweitergabe an Dritte</h2>
        <p>Eine Weitergabe personenbezogener Daten geschieht erfolgt im Rahmen des
          Beratungsprozesses an ausgewählte Dritte, mit denen wir bestehende
          Kooperationsvereinbarungen haben. Darunter fallen:</p>
        <ul>
          <li>Rechtsanwälte und Steuerberater</li>
          <li>Banken&nbsp; und Versicherungen</li>
          <li>Dienstleister im Immobilienbereich (insbesondere Immobilienmakler, Planungsbüros,
            Business Center, Serviced Offices)
          </li>
          <li>Unternehmens- und Förderberatung</li>
          <li>Anbieter von Marktforschung und Standortanalysen</li>
          <li>Personalberater und -vermittler</li>
          <li>Call Center</li>
          <li>Digital Marketing Agencies</li>
          <li>Logistik- und Speditionsanbieter</li>
          <li>Forschungszentren</li>
          <li>Anbieter von Relocation Services (insbesondere Serviced Apartments, Übersetzungdienste
            und Relocation Agenturen)
          </li>
          <li>VC/PE – Finanzierung / Investor</li>
          <li>Betreiber von Film Locations</li>
          <li>Landesansiedelungsagenturen der Bundesländer</li>
          <li>Außenwirtschaftscenter der Wirtschaftskammer Österreich</li>
          <li>Vertragspartner, mit denen die ABA ein aufrechte Vertragsverhältnisse zur Erbringung
            der kostenlosen Dienstleistungen hat
          </li>
        </ul>
        <p>Weiters werden im Rahmen des österreichischen Datenschutzgesetzes 2000 (DSG 2000),
          insbesondere, sofern wir rechtlich dazu verpflichtet sind, Daten an Gerichte oder Behörden
          herausgegeben.</p>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-recht-auf-auskunft-berichtigung-und-loeschung-der-daten-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Recht auf Auskunft, Berichtigung und Löschung der Daten</h2>
        <p>Wenn Sie Fragen zum Datenschutz haben oder Auskunft über Sie betreffende personenbezogene
          Daten verlangen möchten, diese berichtigen oder löschen lassen möchten, nutzen Sie bitte
          unser&nbsp;<a href="/kontakt">Kontaktformular</a>&nbsp;oder senden Sie eine E-Mail an&nbsp;<a
            href="mailto:office@aba.gv.at">office@aba.gv.at</a>.</p>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-aenderung-dieser-erklaerung-zum-schutz-der-privat-und-persoenlichkeitssphaere-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Änderung dieser Erklärung zum Schutz der Privat- und Persönlichkeitssphäre</h2>
        <p>Wir können diese Datenschutzerklärung von Zeit zu Zeit nach eigenem Ermessen ändern oder
          ergänzen. Wenn wir Änderungen an dieser Datenschutzerklärung vornehmen, werden wir das
          Datum der Überarbeitung oben auf der Seite angeben. Die ergänzte oder geänderte
          Datenschutzerklärung ist für Sie und Ihre Informationen ab diesem Datum wirksam. Wir
          empfehlen Ihnen, diese Datenschutzerklärung regelmäßig zu überprüfen, damit Sie darüber
          informiert sind, wie wir Ihre Informationen schützen.</p>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-cookies-und-web-beacons-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Cookies und Web Beacons</h2>
        <p>Die Website sammelt standardmäßig Internetprotokolldaten einschließlich Ihrer IP Adresse,
          Browser Auswahl und Sprache, Datum und Zeit Ihres Besuchs sowie die Website, von der Sie
          auf unsere Website gelangt sind. Um unsere Website effizient zu verwalten und die
          Navigation zu verbessern, können wir oder unser/e Service-Provider Cookies (kleine
          Textdateien, die im Browser des Nutzers abgespeichert werden) oder Web-Beacons
          (elektronische Bilder, die es der Website ermöglichen, die Besucher bestimmter Seiten zu
          zählen und auf bestimmte Cookies zuzugreifen) verwenden, um aggregierte Nutzungsdaten zu
          erheben. Folgende Cookies verwenden wir:</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-google-analytics-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Google Analytics</h3>
        <p>Diese Website benutzt Google Analytics 4 mit Signale, einen Webanalysedienst der Google
          Inc. („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien, die 14 Monate auf
          Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website&nbsp;
          durch Sie ermöglichen, sowie sog. "Signale". Google Signale sind Sitzungsdaten von
          Webseiten und Apps, die die Suchmaschine mit Usern verknüpft, die in ihrem Google-Konto
          angemeldet sind und personalisierte Werbung erlaubt haben. Die durch das Cookie erzeugten
          Informationen über Ihre Benutzung dieser Website (einschließlich der anonymisierten
          IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert.
          Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um
          Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um
          weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu
          erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte übertragen,
          sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google
          verarbeiten. Google wird in keinem Fall Ihre IP-Adresse mit anderen Daten von Google in
          Verbindung bringen. Sie können die Installation der Cookies durch eine entsprechende
          Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie
          in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website in vollem Umfang
          nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung der
          über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem
          zuvor benannten Zweck einverstanden.</p>
        <p>Um die analytische Datensammlung durch Google Analytics zu deaktivieren, können Sie
          diesen Link verwenden:&nbsp;<a href="https://tools.google.com/dlpage/gaoptout"
                                         target="_blank"
                                         title="Browser-Add-on zur Deaktivierung von Google Analytics.">Browser-Add-on
            zur Deaktivierung von Google Analytics</a>&nbsp;.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-google-optimize-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Google Optimize</h3>
        <p>Auf unserer Webseite wird der Webanalyse- und Optimierungsdienst "Google Optimize"
          eingesetzt, die von der Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043,
          USA (im Folgenden "Google Optimize") bereitgestellt werden. Wir nutzen den Dienst Google
          Optimize, um die Attraktivität, den Inhalt und die Funktionalität unserer Webseite zu
          erhöhen, indem wir neue Funktionen und Inhalte einem prozentualen Anteil unserer Nutzer
          ausspielen und die Nutzungsänderung statistisch auswerten. Google Optimize ist ein
          Unterdienst von Google Analytics (siehe Abschnitt Google Analytics).</p>
        <p>Google Optimize verwendet Cookies, über die eine Optimierung und Analyse der Benutzung
          unserer Webseite durch Sie ermöglicht wird. Die durch diese Cookies erzeugten
          Informationen über Ihre Benutzung unserer Webseite werden in der Regel an einen Server von
          Google in den USA übertragen und dort gespeichert. Wir nutzen Google Optimize dabei mit
          aktivierter IP-Anonymisierung, so dass Ihre IP-Adresse von Google innerhalb von
          Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über
          den Europäischen Wirtschaftsraum zuvor gekürzt wird. Nur in Ausnahmefällen wird die volle
          IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Google wird
          diese Informationen benutzen, um Ihre Nutzung unserer Webseite auszuwerten, um Reports
          über die Optimierungstest und die zugehörigen Webseitenaktivitäten zusammenzustellen und
          um weitere mit der Webseitennutzung und der Internetnutzung verbundene Dienstleistungen
          uns gegenüber zu erbringen.</p>
        <p>Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihres
          Internet-Browsers verhindern. Darüber hinaus können Sie die Erfassung der durch das Cookie
          erzeugten und auf Ihre Nutzung unserer Webseite bezogenen Daten (inkl. Ihrer IP-Adresse)
          an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter
          dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren:&nbsp;<a
            href="https://tools.google.com/dlpage/gaoptout?hl=de" target="_blank">https://tools.google.com/dlpage/gaoptout?hl=de</a>.
        </p>
        <p>Nähere Informationen über die Datenerhebung und -verarbeitung durch Google können Sie den
          Datenschutzhinweisen von Google entnehmen, die Sie unter&nbsp;<a
            href="http://www.google.com/policies/privacy" target="_blank">http://www.google.com/policies/privacy</a>&nbsp;abrufen
          können.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-clickdimensions-5989"
                                                               aria-label="Steuerkurs Anker">
</span>ClickDimensions</h3>
        <p>Wir setzen auf unserer Website die Marketing-Automation- und Webtracking-Lösung der
          ClickDimensions LLC, 6849 Peachtree Dunwoody Road, Building B-1, Suite 200, Sandy Springs,
          GA 30328, United States of America („ClickDimensions") ein. Diese verwendet sogenannte
          Cookies (vgl. Cookies und Tracking-Pixel), die auf Ihrem Computer gespeichert werden und
          eine Analyse der Benutzung der Website ermöglichen.</p>
        <p>ClickDimensions verwendet eigene HTML Browser-Cookies in der Web Tracking Technologie.
          Das bedeutet, dass Besucher auf unserer Website ohne weiteres ihre eigenen Browser so
          einstellen können, dass sie Cookies ablehnen, und von uns oder anderen platzierte Cookies
          problemlos entfernen können.</p>
        <p>Um beispielsweise den Browser Internet Explorer so einzustellen, dass Cookies
          zurückgewiesen werden, wählen Sie im Menü: Extras &gt; Internetoptionen &gt; Datenschutz
          &gt; und unter Einstellungen (mit dem Schieber) den gewünschten Datenschutzgrad. Um
          Cookies im Internet Explorer zu löschen, wählen Sie Extras &gt; Internetoptionen &gt;
          Allgemein &gt;, klicken Sie unter Browserverlauf auf die Schaltfläche Löschen, und
          aktivieren Sie im folgenden Dialog die Option Cookies.</p>
        <p>Möchten Sie nicht, dass die Seite ein Cookie setzt, können Sie in Ihrem Browser den
          privaten Modus aktivieren. Die Bezeichnungen für den jeweiligen&nbsp;<a
            href="https://en.wikipedia.org/wiki/Private_browsing" target="_blank">privaten
            Browser-Modus</a>&nbsp;lauten wie folgt:</p>
        <ul>
          <li>InPrivate mode in Microsoft Edge</li>
          <li>InPrivate mode in Microsoft Internet Explorer</li>
          <li>Incognito mode in Google Chrome</li>
          <li>Private browsing mode in Mozilla FireFox</li>
          <li>Private browsing mode in Apple Safari</li>
        </ul>
        <p>ClickDimensions speichert niemals Informationen im LSO-Bereich Ihres Computers, d.h., wir
          verwenden niemals sogenannte 'Flash-Cookies' (Local Shared Objects, kurz LSO).</p>
        <p>ClickDimensions verwendet keine Besucher-Identifikationstechniken, bei denen von Ihnen
          bereitgestellte Informationen mit anderen Websites ausgetauscht werden.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-clickdimenions-newsletter-service-5989"
                                                               aria-label="Steuerkurs Anker">
</span>ClickDimenions Newsletter-Service</h3>
        <p>Um sich für unsere Newsletter anzumelden, reicht es aus, wenn Sie Ihren Namen und
          E-Mail-Adresse angeben. Unsere Newsletter beinhalten Informationen über den
          Wirtschaftsstandort Österreich, unsere Services sowie Veranstaltungshinweise. Die
          Newsletter-Anmeldung, durch die Sie der Speicherung und Verarbeitung Ihrer Daten
          zustimmen, erfolgt im so genannten Double-Opt-In-Verfahren. Das heißt, Sie erhalten nach
          dem Absenden Ihrer Daten eine E-Mail, in der Sie um die Bestätigung Ihrer Anmeldung
          gebeten werden. Ihre E-Mail-Adresse geben wir nicht ohne Ihre Einwilligung an Dritte
          weiter. Sie können den Empfang der Newsletter jederzeit kündigen. Einen Link zur Kündigung
          finden Sie am Ende eines jeden Newsletters.</p>
        <p>Wenn Sie in einem Work in Austria Newsletter Bilder herunterladen oder auf einen Link in
          einer dieser E-Mails klicken, wird dies über den E-Mail-Dienst der ClickDimensions LLC,
          6849 Peachtree Dunwoody Road, Building B-1, Suite 200, Sandy Springs, GA 30328, USA
          („ClickDimensions") automatisch protokolliert. Die erzeugten Nutzungsinformationen werden
          von den Servern der ClickDimensions in den Niederlanden auf unsere Server in Deutschland
          übertragen und dort für statistische Nutzungsanalysen gespeichert. Die Ergebnisse helfen
          uns, die Inhalte unserer Newsletter laufend zu verbessern und das Informationsangebot auf
          unseren Webseiten für Sie interessanter zu gestalten. Wenn Sie mit der Speicherung und
          Auswertung dieser Daten nicht einverstanden sind, können Sie sich über den Link am Ende
          eines jeden Newsletters abmelden.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-facebook-pixel-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Facebook Pixel</h3>
        <p>Wir verwenden auf dieser Webseite das Facebook Pixel von Facebook, einem Social Media
          Network der Firma Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin
          2 Ireland. Der auf dieser Seite implementierte Code kann das Verhalten der Besucher
          auswerten, welche von einer Facebook-Werbung auf diese Webseite gelangt sind. Dies kann
          zur Verbesserung von Facebook-Werbeanzeigen genutzt werden und diese Daten werden von
          Facebook erfasst und gespeichert. Die erfassten Daten sind für uns nicht einsehbar sondern
          nur im Rahmen von Werbeanzeigenschaltungen nutzbar. Durch den Einsatz des
          Facebook-Pixel-Codes werden auch Cookies gesetzt.</p>
        <p>Durch die Nutzung des Facebook-Pixels wird der Besuch dieser Webseite Facebook
          mitgeteilt, damit Besucher auf Facebook passende Anzeigen zu sehen bekommen. Wenn Sie ein
          Facebook-Konto besitzen und angemeldet sind, wird der Besuch dieser Webseite Ihrem
          Facebook-Benutzerkonto zugeordnet. Wie das Facebook-Pixel für Werbekampagnen genutzt wird,
          erfahren Sie auf&nbsp;<a href="https://www.facebook.com/business/learn/facebook-ads-pixel"
                                   target="_blank">https://www.facebook.com/business/learn/facebook-ads-pixel</a>.
        </p>
        <p>Sie können Ihre Einstellungen für Werbeanzeigen in Facebook auf&nbsp;<a
          href="https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen"
          target="_blank">https://www.facebook.com/ads/preferences/?entry_product=ad_settings_screen</a>&nbsp;verändern,
          sofern Sie in Facebook angemeldet sind.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-linkedin-insight-tag-5989"
                                                               aria-label="Steuerkurs Anker">
</span>LinkedIn Insight Tag</h3>
        <p>Wir verwenden auf unserer Webseite das LinkedIn Insight Tag, ein Conversion Tool der
          LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Irland.</p>
        <p>Mithilfe dieser Technologie können Besuchern dieser Webseite personalisierte
          Werbeanzeigen auf LinkedIn ausgespielt werden. Des Weiteren entsteht die Möglichkeit,
          anonyme Berichte zur Performance der Werbeanzeigen sowie Informationen zur
          Webseiteninteraktion zu erstellen. Hierzu ist das LinkedIn Insight-Tag auf dieser Webseite
          eingebunden, wodurch eine Verbindung zum LinkedIn-Server hergestellt wird, sofern Sie
          diese Webseite besuchen und parallel in Ihrem LinkedIn-Account eingeloggt sind.</p>
        <p>In der Datenschutzrichtlinie von LinkedIn unter&nbsp;<a
          href="https://www.linkedin.com/legal/privacy-policy" target="_blank">https://www.linkedin.com/legal/privacy-policy</a>&nbsp;finden
          Sie weitere Informationen zur Datenerhebung und Datennutzung sowie die Möglichkeiten und
          Rechte zum Schutz Ihrer Privatsphäre. Wenn Sie bei LinkedIn eingeloggt sind, können die
          Datenerhebung jederzeit unter folgendem Link deaktivieren:&nbsp;<a
            href="https://www.linkedin.com/psettings/enhanced-advertising" target="_blank">https://www.linkedin.com/psettings/enhanced-advertising</a>.
        </p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-bing-ads-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Bing Ads</h3>
        <p>Auf der Website setzen wir Technologien von Bing Ads (bingads.microsoft.com) ein, welche
          von der Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA
          („Microsoft") bereitgestellt und betrieben werden. Dabei wird von Microsoft ein Cookie auf
          Ihrem Endgerät gesetzt, sofern Sie über eine Microsoft-Bing-Anzeige auf unsere Website
          gelangt sind. Microsoft und wir können auf diese Weise erkennen, dass jemand auf eine
          Anzeige geklickt hat, zu unserer Website weitergeleitet wurde und eine vorher bestimmte
          Zielseite („Conversion Site") erreicht hat. Wir erfahren dabei nur die Gesamtzahl der
          Nutzer, die auf eine Bing Anzeige geklickt haben und dann zur Conversion Site
          weitergeleitet wurden. Microsoft erhebt, verarbeitet und nutzt über das Cookie
          Informationen, aus denen unter Verwendung von Pseudonymen Nutzungsprofile erstellt werden.
          Diese Nutzungsprofile dienen der Analyse des Besucherverhaltens und werden zur Ausspielung
          von Werbeanzeigen verwendet. Es werden keine persönlichen Informationen zur Identität des
          Nutzers verarbeitet.</p>
        <p>Wenn Sie nicht möchten, dass Informationen zu Ihrem Verhalten von Microsoft wie oben
          erläutert verwendet werden, können Sie das hierfür erforderliche Setzen eines Cookies
          ablehnen – etwa per Browser-Einstellung, die das automatische Setzen von Cookies generell
          deaktiviert. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und
          auf Ihre Nutzung der Website bezogenen Daten sowie die Verarbeitung dieser Daten durch
          Microsoft verhindern, indem Sie unter dem folgenden Link&nbsp;<a
            href="https://choice.microsoft.com/de-DE/opt-out" target="_blank">https://choice.microsoft.com/de-DE/opt-out</a>&nbsp;Ihren
          Widerspruch erklären. Weitere Informationen zum Datenschutz und zu den eingesetzten
          Cookies bei Microsoft und Bing Ads finden Sie auf der Website von Microsoft&nbsp;<a
            href="https://privacy.microsoft.com/de-de/privacystatement" target="_blank">https://privacy.microsoft.com/de-de/privacystatement</a>.
        </p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-social-media-anwendungen-5989"
                                                               aria-label="Steuerkurs Anker">
</span>Social Media Anwendungen</h3>
        <p>Die Website verwendet verschiedene Social Media Anwendungen oder Dienste, die Ihnen das
          Teilen von Inhalten mit anderen Nutzern erlaubt. Alle persönlichen Informationen oder
          andere Informationen, die Sie zu Social Media Anwendungen beitragen, können gelesen,
          gesammelt und von anderen Nutzern dieser Social Media-Anwendung genutzt werden, über die
          wir wenig oder keine Kontrolle haben. Daher sind wir nicht verantwortlich für Missbrauch
          oder die Zweckentfremdung von persönlichen Informationen oder sonstigen Informationen
          durch einen anderen Benutzer, die Sie zu einer Social Media-Anwendung beitragen.</p>
        <p>Wir binden auf unserer Website die nachfolgend aufgeführten sozialen Netzwerke ein:</p>
        <ul>
          <li>LinkedIn</li>
          <li>Facebook</li>
          <li>Twitter</li>
        </ul>
      </div>
      <div>
        <h2 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-beschaeftigtendatenschutz-vereinbarung-nach-art-28-dsgvo-ueber-auftragsverarbeitung-einwilligung-5990"
                                                               aria-label="Steuerkurs Anker">
</span>Beschäftigtendatenschutz (Vereinbarung nach Art. 28 DSGVO über Auftragsverarbeitung,
          Einwilligung)</h2>
        <p>bei Beratung und Unterstützung von Unternehmen mit Sitz und/oder Betriebsstätte/n in
          Österreich zur Erlangung der Berechtigungen für die Beschäftigung von internationalen
          Fachkräften (Personen ohne österreichische Staatsbürgerschaft) und/oder bei
          diesbezüglicher Beratung und Unterstützung der internationalen Fachkräfte selbst.</p>
        <h3 class="h3 anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                                 id="h-1-begriffsbestimmungen-abkuerzungen-5990"
                                                                 aria-label="Steuerkurs Anker">
</span>1. Begriffsbestimmungen, Abkürzungen</h3>
        <p>1.1 Die Abkürzung „ABA“ bezeichnet im Folgenden die Business Agency österreichische
          Industrie-ansiedlungs- und WirtschaftswerbungsgmbH. Diese GmbH ist eine gemeinnützige
          Gesellschaft zur Förderung des Wirtschaftsstandortes Österreich. Im Rahmen ihrer
          Förderungsaufgaben ist die ABA unter anderem Kompetenzzentrum und Servicestelle für
          rechtliche Angelegenheiten bei der Anstellung internationaler Fachkräfte in
          Österreich.</p>
        <p>1.2 Der Begriff „internationale Fachkraft“ bezeichnet jede Person, die als
          unselbständiger Arbeit-nehmer eine Beschäftigung in Österreich antreten soll, jedoch nicht
          die österreichische Staats-bürgerschaft besitzt.</p>
        <p>1.3 Die folgenden Bestimmungen gelten für jene Rechtssachen, in welchen sich ein
          Unternehmen mit Sitz und/oder Betriebsstätte/n in Österreich als Arbeitgeber mit einer
          internationalen Fach-kraft (Punkt 1.2) auf deren Beschäftigung in Österreich verständigt
          hat, diese Beschäftigung von Seite der zuständigen Behörden, falls erforderlich, vorläufig
          aber noch nicht bewilligt ist.</p>
        <p>1.4 Die Abkürzung „AuslBG“ steht für das Ausländerbeschäftigungsgesetz, „NAG“ für das
          Nieder-lassungs- und Aufenthaltsgesetz jeweils in der geltenden Fassung (idgF).</p>
        <p>1.5 DSGVO“ steht für die Verordnung (EU) 2016/679 - Datenschutz-Grundverordnung.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-2-rechtsbelehrung-5990"
                                                               aria-label="Steuerkurs Anker">
</span>2. Rechtsbelehrung</h3>
        <p>2.1 Arbeitgeber und Arbeitnehmer (Punkt 1.3) werden über die österreichische Rechtslage
          belehrt, dass eine internationale Fachkraft (von Ausnahmen wie etwa aus EU-Mitgliedstaaten
          stam-mende Personen abgesehen) in Österreich nur beschäftigt werden darf bzw. eine
          Beschäftigung oder eine sonstige Erwerbstätigkeit in Österreich nur antreten und ausüben
          darf, wenn für sie</p>
        <p>2.1.1 eine Beschäftigungsbewilligung oder Entsendebewilligung erteilt</p>
        <p>2.1.2 oder eine Anzeigebestätigung ausgestellt wurde</p>
        <p>2.1.3 oder wenn sie einen für diese Beschäftigung oder eine sonstige Erwerbstätigkeit
          gültigen Aufenthaltstitel besitzt, und zwar</p>
        <ul>
          <li>entweder eine „Rot-Weiß-Rot – Karte“ oder eine „Rot-Weiß-Rot – Karte plus“</li>
          <li>oder eine „Blaue Karte EU“,</li>
          <li>oder eine Aufenthaltsbewilligung als unternehmensintern transferierter Arbeit- nehmer
            („ICT“)
          </li>
          <li>oder eine Aufenthaltsbewilligung als mobiler unternehmensintern transferierter
            Arbeitnehmer („mobile ICT“)
          </li>
          <li>oder eine „Niederlassungsbewilligung“</li>
          <li>oder eine „Niederlassungsbewilligung – Künstler“</li>
          <li>oder eine „Niederlassungsbewilligung – Forscher“</li>
          <li>oder eine „Niederlassungsbewilligung – Sonderfälle unselbständiger Erwerbs-
            tätigkeit“
          </li>
          <li>oder eine „Niederlassungsbewilligung – Angehöriger“</li>
          <li>oder einen Befreiungsschein oder einen Aufenthaltstitel „Familienangehöriger“</li>
          <li>oder einen Aufenthaltstitel „Daueraufenthalt –EU“</li>
        </ul>
        <p>2.1.4 und/oder wenn sie über eine von Gesetzes wegen sonst vorgesehene Berechtigung
          verfügt (Aufenthaltstitel und dgl.).</p>
        <p>2.2 Diese Bewilligungen bzw. Aufenthaltstitel werden im Regelfall befristet erteilt.</p>
        <p>2.3 Bereits vor Beginn der Beschäftigung muss eine der genannten Bewilligungen erteilt
          sein, wo-bei neben den Kriterien des Ausländerbeschäftigungsgesetzes die
          fremdenrechtlichen Voraus-setzungen für den Aufenthalt in Österreich zu beachten sind
          (NAG).</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-3-beratung-und-unterstuetzung-antragstellung-fristen-5990"
                                                               aria-label="Steuerkurs Anker">
</span>3 Beratung und Unterstützung, Antragstellung, Fristen</h3>
        <p>3.1 In Rechtssachen der oben in Punkt 1.3 beschriebenen Art, sobald ein Unternehmen einer
          inter-nationalen Fachkraft eine Jobzusage gegeben hat, erteilt die ABA entweder dem
          Unternehmen und/oder der Fachkraft jeweils auf Anfrage Basisinformationen über die
          grundlegenden Rechts-vorschriften zur Erlangung der für die Beschäftigung in Österreich
          vorgeschriebenen Bewilligungen und das diesbezügliche Verfahren. In die Stellenbesetzung
          (Jobzusage) im Einzelfall allenfalls involvierten Ansiedlungsagenturen der Bundesländer
          und/oder Personaldienstleistern gewährt die ABA zum Vorteil des Unternehmens und/oder der
          Fachkraft ebenfalls Beratung und Unterstützung.</p>
        <p>3.2 Die Antragstellung erfolgt durch das Unternehmen und/oder durch die internationale
          Fachkraft (verfahrensbezogen Partei genannt); dies auf Wunsch unter Anleitung von Seite
          der ABA.</p>
        <p>3.3 Nach der Antragstellung unterstützt die ABA die antragstellende/n Partei/en, sohin
          das Unter-nehmen und/oder die Fachkraft durch eine Begleitung bei den einzelnen
          Verfahrensschritten. Dazu ermächtigt die Partei/ermächtigen die Parteien die ABA bis auf
          jederzeitigen Widerruf, bei den zuständigen Behörden Informationen über den Stand des
          betreuten Verfahrens, über allenfalls noch einzubringende Unterlagen und über die
          voraussichtliche Dauer des Verfahrens zu erhalten und Einsicht in die Verfahrensakten zu
          nehmen.</p>
        <p>3.4 Insoweit die o. a. Bewilligungen bzw. Aufenthaltstitel befristet erteilt werden
          (Punkt 2.2), über-nimmt die ABA für eine etwaige Antragstellung auf Verlängerung die
          Überwachung der Fristen, es sei denn, eine Fristenüberwachung wird von Seite des
          Unternehmens und/oder der Fachkraft nicht gewünscht.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-4-beschaeftigtendaten-personenbezogene-daten-dokumente-5990"
                                                               aria-label="Steuerkurs Anker">
</span>4 Beschäftigtendaten, personenbezogene Daten, Dokumente</h3>
        <p>4.1 Der ABA ist die in Rechtssachen der oben in Punkt 1.3 beschriebenen Art gewünschte
          Beratung und Unterstützung nur möglich, wenn ihr von Seite des Unternehmens und/oder der
          Fachkraft die personenbezogenen Daten der internationalen Fachkraft (im Folgenden kurz
          Beschäftigten-daten genannt), zudem jene des Unternehmens, ferner die für die
          Antragstellung (Punkt 3.2) notwendigen Dokumente zur Verfügung gestellt werden.</p>
        <p>4.2 Bei diesen Daten und Dokumenten handelt es sich im Einzelnen insbesondere um
          folgende:</p>
        <p>4.2.1 ausgefülltes und gezeichnetes/unterschriebenes Antragsformular, in welchem
          sämtliche relevanten personenbezogenen Daten anzugeben sind,</p>
        <p>4.2.2 Angaben und Dokumente von Seite des Unternehmens, und zwar</p>
        <ul>
          <li>Stellenbeschreibung,</li>
          <li>Arbeitgebererklärung,</li>
          <li>allenfalls zusätzliche Stellungnahme/n,</li>
        </ul>
        <p>4.2.3 Beschäftigtendaten und diesbezügliche Dokumente der Fachkraft, und zwar</p>
        <ul>
          <li>Geburtsurkunde (allenfalls auch jene von Familienmitgliedern),</li>
          <li>Lebenslauf der internationalen Fachkraft,</li>
          <li>Strafregisterbescheinigung,</li>
          <li>allenfalls Heiratsurkunde oder Partnerschaftsurkunde oder sonstige
            Personenstandsurkunde/n,
          </li>
          <li>Reisepass,</li>
          <li>Passfoto mit Rechnung,</li>
          <li>allenfalls bereits bestehende Aufenthaltstitel,</li>
          <li>allenfalls bereits erteilte Visa,</li>
        </ul>
        <p>4.2.4 stellenbezogene Daten bzw. Dokumente, und zwar</p>
        <ul>
          <li>Jobzusage (von beiden Seiten unterschriebenes Jobangebot),</li>
          <li>Urkunde/n zum Nachweis der Qualifikation bzw. Ausbildung (Schulzeugnis/se, Abschluss-
            bzw. Universitätsdiplom/e, Teilnahmebestätigung/en usw.),
          </li>
          <li>Urkunde/n zum Nachweis der Berufserfahrung und/oder von Vordienstzeiten
            (Dienstzeugnis/se, Bestätigung/en über Sozialversicherungszeiten, sonstige Nachweise,
            etwa über vorgängige selbständige Tätigkeit/en usw.),
          </li>
          <li>Sprachzertifikat/e,</li>
          <li>allenfalls weitere „Skill Certificates“ und dgl.</li>
        </ul>
        <p>4.3 Diese Daten und Dokumente, welche das Unternehmen und/oder die internationale
          Fachkraft (bzw. in dessen/deren Auftrag und Interesse entweder eine Ansiedlungsagentur
          eines Bundes-landes oder ein Personaldienstleister) der ABA freiwillig zur Verfügung
          stellt/stellen, speichert, verwendet (einschließlich Weitergabe) und verarbeitet die ABA
          nur für die in Punkt 3 beschrie-benen Zwecke der Beratung und Unterstützung in den
          Rechtssachen der oben in Punkt 1.3 beschriebenen Art.</p>
        <p>4.4 Die ABA legt auf den Schutz von personenbezogenen Daten größten Wert. Sie beachtet
          dazu die anwendbaren Rechtsvorschriften zum Schutz, rechtmäßigen Umgang und zur
          Geheimhaltung personenbezogener Daten sowie zur Datensicherheit, insbesondere das
          österreichische Datenschutzgesetz (DSG), die EU-Datenschutzgrundverordnung (DSGVO) sowie
          das Telekommuni-kationsgesetz (TKG).</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-5-vereinbarung-nach-art-28-dsgvo-ueber-auftragsverarbeitung-unternehmen-ansiedlungsagentur-personaldienstleister-5990"
                                                               aria-label="Steuerkurs Anker">
</span>5 Vereinbarung nach Art. 28 DSGVO über Auftragsverarbeitung (Unternehmen, Ansiedlungsagentur,
          Personaldienstleister)</h3>
        <p>5.1 Einleitung</p>
        <p>5.1.1 Insoweit der ABA die Daten, insbesondere die Beschäftigtendaten und Dokumente
          (Punkt 4) einseitig nur vom Unternehmen zur Verfügung gestellt werden, erfolgen Beratung
          und Unter-stützung durch die ABA im Auftrag des Unternehmens als Verantwortlichen (Art. 28
          DSGVO); dies nach Maßgabe der folgenden Bestimmungen, wobei diese, falls eine
          Ansiedlungsagentur eines Bundeslandes und/oder ein Personaldienstleister involviert sein
          sollte/n (Punkt 3.1 zwei-ter Satz), sinngemäß bzw. gleichermaßen für Agentur und/oder
          Personaldienstleister gelten.</p>
        <p>5.2 Gegenstand und Dauer der Vereinbarung</p>
        <p>5.2.1 Gegenstand des Auftrages ist die Beratung und Unterstützung in einer konkreten
          Rechtssache der in Punkt 1.3 beschriebenen Art.</p>
        <p>5.2.2 Das Auftragsverhältnis endet mit Durchführung der gewünschten Beratung und
          Unterstützung.</p>
        <p>5.2.3 Es endet demnach mit Abschluss des betreuten Verfahrens bzw. mit Erteilung der
          Bewilligung oder mit Fristablauf bei allenfalls beauftragter Fristenüberwachung (Punkt
          3.4).</p>
        <p>5.3 Pflichten der ABA</p>
        <p>5.3.1 Die ABA verpflichtet sich, Daten und/oder Verarbeitungsergebnisse ausschließlich im
          Rahmen der Aufträge des Unternehmens zu verarbeiten. Erhält die ABA einen behördlichen
          Auftrag, überlassene Daten oder Dokumente herauszugeben, so hat die ABA, insoweit dies
          gesetzlich zulässig ist, das Unternehmen unverzüglich darüber zu informieren und die
          Behörde an dieses zu verweisen.</p>
        <p>5.3.2 Die ABA erklärt rechtsverbindlich, dass</p>
        <ul>
          <li>sie alle mit der Datenverarbeitung beauftragten Personen vor Aufnahme der Tätigkeit
            zur Vertraulichkeit schriftlich verpflichtet hat oder diese Personen einer angemessenen
            gesetzlichen Verschwiegenheitsverpflichtung unterliegen
          </li>
          <li>und sie ferner sämtliche erforderlichen Maßnahmen zur Gewährleistung der Sicherheit
            der Verarbeitung nach Art. 32 DSGVO ergriffen hat.
          </li>
        </ul>
        <p>5.3.3 Die ABA ergreift die technischen und organisatorischen Maßnahmen, damit das
          Unternehmen die Rechte der betroffenen Fachkraft nach Kapitel III der DSGVO (Information,
          Auskunft, Be-richtigung und Löschung, Datenübertragbarkeit, Widerspruch, automatisierte
          Entscheidungs-findung im Einzelfall) innerhalb der gesetzlichen Fristen jederzeit erfüllen
          kann und überlässt dem Unternehmen sämtliche dafür notwendigen Informationen. Wird (von
          Seite der Fachkraft) ein entsprechender Antrag an die ABA gerichtet und lässt dieser
          erkennen, dass der Antrag-steller die ABA irrtümlich für den Verantwortlichen der ihr
          betriebenen Datenverarbeitung hält, so hat die ABA den Antrag unverzüglich an das
          Unternehmen weiterzuleiten und dies überdies dem Antragsteller mitzuteilen.</p>
        <p>5.3.4 Die ABA unterstützt das Unternehmen ferner bei der Einhaltung der in den Art 32 bis
          36 DSGVO genannten Pflichten (Datensicherheitsmaßnahmen, Meldungen von Verletzungen des
          Schutzes personenbezogener Daten an die Aufsichtsbehörde, Benachrichtigung der von einer
          Verletzung des Schutzes personenbezogener Daten betroffenen Person usw.).</p>
        <p>5.3.5 Dem Unternehmen wird hinsichtlich der Verarbeitung der von ihm überlassenen Daten
          das Recht jederzeitiger Kontrolle eingeräumt. Die ABA verpflichtet sich diesbezüglich, dem
          Unternehmen jene Informationen zur Verfügung zu stellen, die zur Kontrolle der Einhaltung
          aller in Punkt 5 genannten Verpflichtungen notwendig sind. Die ABA wird das Unternehmen
          ferner informieren, falls sie der Ansicht ist, dass eine Weisung des Unternehmens gegen
          Datenschutzbestimmungen der Union oder der Mitgliedstaaten verstößt.</p>
        <p>5.3.6 Die ABA ist nach Beendigung des Auftragsverhältnisses verpflichtet, sämtliche
          Verarbeitungs-ergebnisse und Unterlagen, die Daten enthalten, dem Unternehmen zu
          übergeben, überdies in dessen Auftrag zu löschen.</p>
        <p>5.4 Erfüllung des Arbeitsvertrages, Schad- und Klagloshaltung</p>
        <p>5.4.1 Vor dem Hintergrund der Jobzusage (Punkte 1.3, 3) ist die Erlangung der für die
          Beschäftigung in Österreich vorgeschriebenen Bewilligung/en zudem für die Erfüllung des
          vom Unternehmen mit der Fachkraft vereinbarten Arbeitsvertrages erforderlich, so dass
          diesbezügliche Beratung und Unterstützung insbesondere auch im Interesse der Fachkraft
          liegen.</p>
        <p>5.4.2 Sollte die Fachkraft dennoch eine Datenschutzverletzung behaupten, wird jenes
          Unternehmen, welches als Verantwortlicher die ABA hinzugezogen hat, diese schad- und
          klaglos halten.</p>
        <p>5.5 Ort der Durchführung der Datenverarbeitung</p>
        <p>5.5.1 Von Seite der ABA werden alle Datenverarbeitungstätigkeiten ausschließlich
          innerhalb der EU bzw. des EWR durchgeführt.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-6-einwilligung-nach-art-6-abs-1-lit-a-dsgvo-internationale-fachkraft-5990"
                                                               aria-label="Steuerkurs Anker">
</span>6 Einwilligung nach Art. 6 Abs. 1 lit. a) DSGVO (internationale Fachkraft)</h3>
        <p>6.1 Einleitung</p>
        <p>6.1.1 Falls sich wegen der Jobzusage (Punkte 1.3, 3) die internationale Fachkraft an die
          ABA wendet und dieser die stellenbezogenen Daten, Beschäftigtendaten und Dokumente (oben,
          Punkt 4) zur Verfügung stellt, willigt sie bis auf Widerruf in die Erhebung, Speicherung
          und Verarbeitung der Daten und Dokumente (Punkt 4) für Zwecke der Beratung und
          Unterstützung bei Erlangung der Bewilligung/en für die Beschäftigung in Österreich ein;
          dies nach Maßgabe des in Punkt 3 umschriebenen Leistungsumfangs.</p>
        <p>6.1.2 Zu diesen Zwecken ermächtigt die Fachkraft die ABA, alles zu unternehmen und
          vorzukehren, was die ABA nach ihrer Einsicht für nötig und nützlich erachtet. In diesem
          Sinne wird die ABA von der Fachkraft insbesondere auch ermächtigt, Daten und Dokumente,
          falls dies notwendig oder zweckmäßig ist, an beteiligte Behörden bzw. relevante Stellen
          weiterzugeben, etwa an</p>
        <ul>
          <li>das Arbeitsmarkservice (AMS) bzw. dessen regionale Geschäftsstellen,</li>
          <li>das Anerkennungs-, Antrags und Informationssystem (AAIS) des zuständigen
            Bundes-ministeriums, das ENIC NARIS (National Academic Recognition Centre) AUSTRIA,
          </li>
          <li>die Bundesministerien, insbesondere etwa an das Bundesministerium (BM) für Inneres,
            das BM für Arbeit, das BM für Europäische und internationale Angelegenheiten, das BM für
            Bildung, Wissenschaft und Forschung,
          </li>
          <li>die Aufenthaltsbehörden der Bundesländer, insbesondere Bezirkshauptmannschaften und
            Ämter der Landesregierungen,
          </li>
          <li>österreichische Vertretungsbehörden im Ausland (Botschaften, Konsulate),</li>
          <li>des Weiteren, etwa für Rückfragen, an jene Behörden und Stellen, welche Dokumente
            ausgestellt haben.
          </li>
        </ul>
        <p>6.1.3 Insoweit sich Daten und/oder überlassene Dokumente auf Familienangehörige der
          Fachkraft beziehen sollten (Punkt 4.2.3), erklärt diese, dass auch von Seite der
          betroffenen Angehörigen eine Einwilligung dahin vorliegt, dass die ABA im Interesse der
          Fachkraft zu den in Punkt 3 bezeichneten Zwecken uneingeschränkt tätig werden kann.</p>
        <p>6.2 Freiwilligkeit</p>
        <p>6.2.1 Die Fachkraft wird darauf hingewiesen, dass die Erhebung, Speicherung,
          Verarbeitung, Nutzung und allfällige Weitergabe (Punkt 6.1.2) der Daten und Dokumente auf
          freiwilliger Basis erfolgt.</p>
        <p>6.2.2 Wird dazu die Einwilligung nicht erteilt, entstehen der Fachkraft keine Nachteile,
          die ABA kann in einem solchen Fall die Fachkraft allerdings weder beraten oder
          unterstützen noch ein von ihr eingeleitetes Verfahren betreuen.</p>
        <p>6.3 Widerruf</p>
        <p>6.3.1 Die internationale Fachkraft hat das Recht, ihre Einwilligung jederzeit zu
          widerrufen.</p>
        <p>6.3.2 Durch den Widerruf wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum
          Widerruf erfolgten Verarbeitung nicht berührt.</p>
        <p>6.4 Betroffenenrechte</p>
        <p>6.4.1 Informiert wird die Fachkraft, dass ihr nach den Bestimmungen der Art. 12 ff der
          Datenschutz-Grundverordnung die folgenden Rechte zustehen, und zwar:</p>
        <ul>
          <li>das Auskunftsrecht nach Art. 15 DSGVO (Werden personenbezogene Daten verarbeitet, so
            hat die betroffene Person das Recht, Auskunft über die zu ihrer Person gespeicherten
            Daten zu erhalten.),
          </li>
          <li>das Recht auf Berichtigung nach Art. 16 DSGVO (Werden unrichtige personenbezogene
            Daten verarbeitet, steht der betroffenen Person ein Recht auf Berichtigung zu.),
          </li>
          <li>das Recht auf Löschung nach Art. 17 DSGVO (Bei Vorliegen der rechtlichen
            Voraussetzungen kann die betroffene Person die Löschung der zu ihrer Person
            gespeicherten Daten verlangen.),
          </li>
          <li>das Recht auf Einschränkung der Verarbeitung nach Art. 18 DSGVO,</li>
          <li>das Recht nach Art. 21 DSGVO, Widerspruch gegen die Verarbeitung einzulegen,</li>
          <li>gegebenenfalls (ggf.) ein Recht auf Datenübertragbarkeit nach Art. 20 DSGVO (Dieses
            Recht steht der betroffenen Person ggf. zu, wenn sie in die Datenverarbeitung
            eingewilligt hat oder ein Vertrag zur Datenverarbeitung besteht und die
            Datenverarbeitung mithilfe automatisierter Verfahren durchgeführt wird.).
          </li>
        </ul>
        <p>6.4.2 Sollte eine betroffene Person allenfalls der Auffassung sein, dass die Verarbeitung
          ihrer Daten gegen das Datenschutzrecht verstößt oder ihre datenschutzrechtlichen Ansprüche
          allenfalls sonst verletzt, hat sie überdies das Recht, sich bei der österreichischen
          Datenschutzbehörde oder bei einer Aufsichtsbehörde innerhalb der EU zu beschweren. Die
          österreichische Daten-schutzbehörde ist unter der folgenden Adresse erreichbar, und zwar:
          Österreichische Datenschutzbehörde, 1030 Wien, Barichgasse 40-42 Telefonnummer: +43 1
          52152-0, E-Mail: dsb@dsb.gv.at.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-7-unentgeltlichkeit-kein-rechtsanspruch-5990"
                                                               aria-label="Steuerkurs Anker">
</span>7 Unentgeltlichkeit, kein Rechtsanspruch</h3>
        <p>7.1 In Rechtssachen der oben in Punkt 1.3 beschriebenen Art, erbringt die ABA die in
          Punkt 3 näher beschriebenen Leistungen an Beratung und Unterstützung unentgeltlich.</p>
        <p>7.2 Ein Rechtsanspruch auf diese Leistungen besteht nicht.</p>
        <h3 class=" anchor-headline rte-anchor-headline"><span class="anchor-headline-link"
                                                               id="h-stand-der-datenschutzerklaerung-16-august-2022-5990"
                                                               aria-label="Steuerkurs Anker">
</span>Stand der Datenschutzerklärung: 16. August 2022</h3>
      </div>
    </div>
  </b-modal>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class PrivacyPolicyModal extends Vue {
}
</script>
<style scoped lang="scss">
.privacy-policy {
  h1 {
    font-size: 38px;
  }
  h2 {
    font-size: 32px;
  }
  h3 {
    font-size: 28px;
  }
  p {
    font-size: 16px;
  }
}
</style>
